export default __webpack_public_path__ + "static/media/hoitokeskustelu-white.b4244c70.svg";